import {GeneratedApis} from '../types/api-definition';
import {ApiDef} from 'aegis-api-proxy';
const loginType = localStorage.getItem('loginType');
export default {
  accident: {
    getAccidentDetail: {
      url: '/accident',
      method: 'GET',
      requestData(accidentId: number) {
        return this.r({accidentId});
      }
    },
    cancellation: {
      url: '/accident/cancellation',
      method: 'POST',
      isFormData: true,
      requestData(accidentId: number) {
        return this.r({accidentId});
      }
    },
    claim: {
      url: '/accident/claim',
      method: 'POST',
      isFormData: false,
      getClaim: {
        url: '/accident/claim',
        method: 'GET'
      }
    },
    create: {
      url: '/accident/create',
      method: 'POST',
      isFormData: false
    },
    interface: {
      drivingLicenseNum: {
        getDriverInfoByDrivingLicenseNum: {
          url: '/accident/interface/drivingLicenseNum',
          method: 'GET',
          requestData(number: string) {
            return this.r({number});
          }
        }
      },
      photo: {
        IdCard: {
          getIdCardByIdCardPhoto: {
            url: '/accident/interface/photo/IdCard',
            method: 'GET',
            requestData(photoUrl: string) {
              return this.r({photoUrl});
            }
          }
        },
        carLicense: {
          getCarInfoByCarLicensePhoto: {
            url: '/accident/interface/photo/carLicense',
            method: 'GET',
            requestData(photoUrl: string) {
              return this.r({photoUrl});
            }
          }
        },
        drivingLicense: {
          getDrivingLicenseNumByDrivingLicensePhoto: {
            url: '/accident/interface/photo/drivingLicense',
            method: 'GET',
            requestData(photoUrl: string) {
              return this.r({photoUrl});
            }
          }
        },
        face: {
          getPeopleInfoByFacePhoto: {
            url: '/accident/interface/photo/face',
            method: 'GET',
            requestData(photoUrl: string) {
              return this.r({photoUrl});
            }
          }
        }
      }
    },
    liability: {
      url: '/accident/liability',
      method: 'POST',
      isFormData: true
    },
    list: {
      listAccidents: {
        url: '/accident/list',
        method: 'GET'
      },
      export: {
        exportAccidents: {
          url: '/accident/list/export',
          method: 'GET'
        }
      },
      today: {
        listTodayAccidents: {
          url: '/accident/list/today',
          method: 'GET'
        }
      }
    },
    log: {
      get: {
        url: '/accident/log',
        method: 'GET'
      }
    },
    save: {
      url: '/accident/save',
      method: 'POST',
      isFormData: true,
      requestData(type: number) {
        return this.r({type});
      }
    },
    simulate: {
      getSimulate: {
        url: '/accident/simulate',
        method: 'GET',
        requestData(accidentId: number) {
          return this.r({accidentId});
        }
      },
      complete: {
        completeSimulateAccident: {
          url: '/accident/simulate/complete',
          method: 'POST',
          isFormData: true
        }
      },
      get: {
        getSimulateAccident: {
          url: '/accident/simulate/get',
          method: 'GET'
        }
      },
      replenish: {
        replenishSimulateAccident: {
          url: '/accident/simulate/replenish',
          method: 'POST',
          isFormData: true
        },
        get: {
          getReplenishSimulateAccident: {
            url: '/accident/simulate/replenish/get',
            method: 'GET'
          }
        }
      }
    },
    sms: {
      send: {
        url: '/accident/sms',
        method: 'POST',
        isFormData: false
      }
    },
    upload: {
      uploadStatement: {
        url: '/accident/upload',
        method: 'POST',
        isFormData: true
      },
      delete: {
        deleteStatement: {
          url: '/accident/upload/delete',
          method: 'GET',
          requestData(accidentId: number) {
            return this.r({accidentId});
          }
        }
      }
    }
  },
  auth: {
    openId: {
      getOpenId: {
        url: '/auth/openId',
        method: 'GET',
        requestData(code: string) {
          return this.r({code});
        }
      }
    }
  },
  getInfo: {
    url: '/getInfo',
    method: 'GET'
  },
  getRouters: {
    url: '/getRouters',
    method: 'GET'
  },
  login: {
    url: '/login?loginType=' + loginType,
    method: 'POST',
    isFormData: false
  },
  message: {
    common: {
      sendCommonMessage: {
        url: '/message/common',
        method: 'GET'
      }
    },
    hospital: {
      sendHospitalMessage: {
        url: '/message/hospital',
        method: 'POST',
        isFormData: false
      }
    },
    rescue: {
      sendMessage: {
        url: '/message/rescue',
        method: 'POST',
        isFormData: false
      }
    }
  },
  monitor: {
    job: {
      export: {
        url: '/monitor/job/export',
        method: 'GET'
      }
    },
    jobLog: {
      export: {
        url: '/monitor/jobLog/export',
        method: 'GET'
      }
    },
    logininfor: {
      export: {
        url: '/monitor/logininfor/export',
        method: 'GET'
      }
    },
    operlog: {
      export: {
        url: '/monitor/operlog/export',
        method: 'GET'
      }
    }
  },
  position: {
    data: {
      parseData: {
        url: '/position/data',
        method: 'GET'
      }
    },
    location: {
      getLocation: {
        url: '/position/location',
        method: 'GET',
        requestData(address: string) {
          return this.r({address});
        }
      }
    },
    organization: {
      getOrganization: {
        url: '/position/organization',
        method: 'GET'
      }
    }
  },
  system: {
    config: {
      add: {
        url: '/system/config',
        method: 'POST',
        isFormData: false
      },
      update: {
        url: '/system/config',
        method: 'PUT',
        isFormData: false
      },
      clearCache: {
        url: '/system/config/clearCache',
        method: 'DELETE',
        isFormData: true
      },
      refreshCache: {
        url: '/system/config/refreshCache',
        method: 'DELETE',
        isFormData: true
      },
      configKey: {
        getConfigKey: {
          url: '/system/config/configKey/:configKey',
          method: 'GET',
          requestData(configKey: string) {
            return this.r({configKey});
          }
        }
      },
      export: {
        url: '/system/config/export',
        method: 'GET'
      },
      list: {
        url: '/system/config/list',
        method: 'GET'
      },
      remove: {
        url: '/system/config/:configIds',
        method: 'DELETE',
        isFormData: true,
        requestData(configIds: string) {
          return this.r({configIds});
        }
      },
      getInfo: {
        url: '/system/config/:configId',
        method: 'GET',
        requestData(configId: number) {
          return this.r({configId});
        }
      }
    },
    dict: {
      data: {
        export: {
          url: '/system/dict/data/export',
          method: 'GET'
        },
        type: {
          dictType: {
            url: '/system/dict/data/type/:dictType',
            method: 'GET',
            requestData(dictType: string) {
              return this.r({dictType});
            }
          }
        },
        types: {
          getByTypes: {
            url: '/system/dict/data/types',
            method: 'POST',
            isFormData: false
          }
        }
      },
      type: {
        add: {
          url: '/system/dict/type',
          method: 'POST',
          isFormData: false
        },
        edit: {
          url: '/system/dict/type',
          method: 'PUT',
          isFormData: false
        },
        clearCache: {
          url: '/system/dict/type/clearCache',
          method: 'DELETE',
          isFormData: true
        },
        export: {
          url: '/system/dict/type/export',
          method: 'GET'
        },
        list: {
          url: '/system/dict/type/list',
          method: 'GET'
        },
        optionselect: {
          url: '/system/dict/type/optionselect',
          method: 'GET'
        },
        remove: {
          url: '/system/dict/type/:dictIds',
          method: 'DELETE',
          isFormData: true,
          requestData(dictIds: string) {
            return this.r({dictIds});
          }
        },
        getInfo: {
          url: '/system/dict/type/:dictId',
          method: 'GET',
          requestData(dictId: number) {
            return this.r({dictId});
          }
        }
      }
    },
    post: {
      export: {
        url: '/system/post/export',
        method: 'GET'
      }
    },
    role: {
      add: {
        url: '/system/role',
        method: 'POST',
        isFormData: false
      },
      edit: {
        url: '/system/role',
        method: 'PUT',
        isFormData: false
      },
      changeStatus: {
        url: '/system/role/change_status',
        method: 'PUT',
        isFormData: false
      },
      dataScope: {
        url: '/system/role/data_scope',
        method: 'PUT',
        isFormData: false
      },
      export: {
        url: '/system/role/export',
        method: 'GET'
      },
      list: {
        url: '/system/role/list',
        method: 'GET'
      },
      optionselect: {
        url: '/system/role/optionselect',
        method: 'GET'
      },
      remove: {
        url: '/system/role/:roleIds',
        method: 'DELETE',
        isFormData: true,
        requestData(roleIds: string) {
          return this.r({roleIds});
        }
      },
      getInfo: {
        url: '/system/role/:roleId',
        method: 'GET',
        requestData(roleId: number) {
          return this.r({roleId});
        }
      }
    },
    user: {
      add: {
        url: '/system/user',
        method: 'POST',
        isFormData: false
      },
      update: {
        url: '/system/user',
        method: 'PUT',
        isFormData: false
      },
      changeStatus: {
        url: '/system/user/changeStatus',
        method: 'PUT',
        isFormData: false
      },
      export: {
        url: '/system/user/export',
        method: 'GET'
      },
      importData: {
        url: '/system/user/importData',
        method: 'POST',
        isFormData: true
      },
      modifyPersonalInfo: {
        url: '/system/user/modify_personal_info',
        method: 'PUT',
        isFormData: false
      },
      policeAndInsuranceList: {
        url: '/system/user/police_and_insurance_list',
        method: 'GET'
      },
      resetPwd: {
        url: '/system/user/resetPwd',
        method: 'PUT',
        isFormData: false
      },
      remove: {
        url: '/system/user/:userIds',
        method: 'DELETE',
        isFormData: true,
        requestData(userIds: string) {
          return this.r({userIds});
        }
      }
    }
  },
  test: {
    user: {
      list: {
        userList: {
          url: '/test/user/list',
          method: 'GET'
        }
      },
      save: {
        url: '/test/user/save',
        method: 'POST',
        isFormData: true
      },
      update: {
        url: '/test/user/update',
        method: 'PUT',
        isFormData: true
      },
      getUser: {
        url: '/test/user/:userId',
        method: 'GET',
        requestData(userId: number) {
          return this.r({userId});
        }
      },
      delete: {
        url: '/test/user/:userId',
        method: 'DELETE',
        isFormData: true,
        requestData(userId: number) {
          return this.r({userId});
        }
      }
    }
  },
  video: {
    trtc: {
      accept: {
        url: '/video/trtc/accept',
        method: 'GET'
      },
      availableCalls: {
        getAvailableCalls: {
          url: '/video/trtc/available_calls',
          method: 'GET'
        }
      },
      call: {
        videoCall: {
          url: '/video/trtc/call',
          method: 'GET'
        }
      },
      callback: {
        videoCallBack: {
          url: '/video/trtc/callback',
          method: 'POST',
          isFormData: false,
          requestData(eventInfo: string) {
            return this.r({eventInfo});
          }
        }
      },
      confirm: {
        url: '/video/trtc/confirm',
        method: 'GET',
        requestData(party: string) {
          return this.r({party});
        }
      },
      hangup: {
        hangUp: {
          url: '/video/trtc/hangup',
          method: 'GET'
        }
      },
      invite: {
        inviteOthers: {
          url: '/video/trtc/invite',
          method: 'GET',
          requestData(inviteeId: string) {
            return this.r({inviteeId});
          }
        }
      },
      leave: {
        url: '/video/trtc/leave',
        method: 'GET'
      },
      onlineUsers: {
        getOnlineUsers: {
          url: '/video/trtc/online_users',
          method: 'GET',
          requestData(condition: string) {
            return this.r({condition});
          }
        }
      },
      ready: {
        url: '/video/trtc/ready',
        method: 'GET'
      },
      refuse: {
        url: '/video/trtc/refuse',
        method: 'GET'
      },
      sign: {
        genSignature: {
          url: '/video/trtc/sign',
          method: 'GET',
          requestData(username: string) {
            return this.r({username});
          }
        }
      },
      startMix: {
        url: '/video/trtc/start_mix',
        method: 'GET'
      }
    }
  },
  workstation: {
    data: {
      getData: {
        url: '/workstation/data',
        method: 'GET'
      }
    },
    status: {
      getStatus: {
        url: '/workstation/status',
        method: 'GET'
      },
      editStatus: {
        url: '/workstation/status',
        method: 'POST',
        isFormData: true,
        requestData(status: number) {
          return this.r({status});
        }
      }
    }
  }
} as GeneratedApis<ApiDef>;
